module.exports = __webpack_public_path__ + "img/avatar-roy-marmelstein.3d0f2598.jpg";